<template>
  <div v-if="form.IdFormulario" class="w-100">
    <form @submit.prevent="submit" class="container mt-lg-5 mb-5 d-flex flex-column gap-3">
      <div class="d-flex flex-column justify-content-center align-items-start gap-2">
        <div class="d-flex gap-2 w-100 pb-2">
          <h2 class="m-0">{{ $t('editarFormulario') }}</h2>
          <div class="d-flex gap-2">
            <button type="submit" class="btn btn-success" :disabled="isSaving">{{ $t('guardar') }}</button>
            <div v-if="isSaving" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
            <button class="btn btn-danger" type="button" @click="cancelForm">{{ $t('cancelar') }}</button>
            <button class="btn" type="button" @click="verOpciones = true">
              <svg width="30" height="30" viewBox="0 0 24 24" class="fill-principal" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 8C9.79111 8 8.00024 9.79086 8.00024 12C8.00024 14.2091 9.79111 16 12.0002 16C14.2094 16 16.0002 14.2091 16.0002 12C16.0002 9.79086 14.2094 8 12.0002 8ZM10.0002 12C10.0002 10.8954 10.8957 10 12.0002 10C13.1048 10 14.0002 10.8954 14.0002 12C14.0002 13.1046 13.1048 14 12.0002 14C10.8957 14 10.0002 13.1046 10.0002 12Z"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2867 0.5C9.88583 0.5 8.6461 1.46745 8.37171 2.85605L8.29264 3.25622C8.10489 4.20638 7.06195 4.83059 6.04511 4.48813L5.64825 4.35447C4.32246 3.90796 2.83873 4.42968 2.11836 5.63933L1.40492 6.83735C0.67773 8.05846 0.954349 9.60487 2.03927 10.5142L2.35714 10.7806C3.12939 11.4279 3.12939 12.5721 2.35714 13.2194L2.03927 13.4858C0.954349 14.3951 0.67773 15.9415 1.40492 17.1626L2.11833 18.3606C2.83872 19.5703 4.3225 20.092 5.64831 19.6455L6.04506 19.5118C7.06191 19.1693 8.1049 19.7935 8.29264 20.7437L8.37172 21.1439C8.6461 22.5325 9.88584 23.5 11.2867 23.5H12.7136C14.1146 23.5 15.3543 22.5325 15.6287 21.1438L15.7077 20.7438C15.8954 19.7936 16.9384 19.1693 17.9553 19.5118L18.3521 19.6455C19.6779 20.092 21.1617 19.5703 21.8821 18.3606L22.5955 17.1627C23.3227 15.9416 23.046 14.3951 21.9611 13.4858L21.6432 13.2194C20.8709 12.5722 20.8709 11.4278 21.6432 10.7806L21.9611 10.5142C23.046 9.60489 23.3227 8.05845 22.5955 6.83732L21.8821 5.63932C21.1617 4.42968 19.678 3.90795 18.3522 4.35444L17.9552 4.48814C16.9384 4.83059 15.8954 4.20634 15.7077 3.25617L15.6287 2.85616C15.3543 1.46751 14.1146 0.5 12.7136 0.5H11.2867ZM10.3338 3.24375C10.4149 2.83334 10.7983 2.5 11.2867 2.5H12.7136C13.2021 2.5 13.5855 2.83336 13.6666 3.24378L13.7456 3.64379C14.1791 5.83811 16.4909 7.09167 18.5935 6.38353L18.9905 6.24984C19.4495 6.09527 19.9394 6.28595 20.1637 6.66264L20.8771 7.86064C21.0946 8.22587 21.0208 8.69271 20.6764 8.98135L20.3586 9.24773C18.6325 10.6943 18.6325 13.3057 20.3586 14.7523L20.6764 15.0186C21.0208 15.3073 21.0946 15.7741 20.8771 16.1394L20.1637 17.3373C19.9394 17.714 19.4495 17.9047 18.9905 17.7501L18.5936 17.6164C16.4909 16.9082 14.1791 18.1618 13.7456 20.3562L13.6666 20.7562C13.5855 21.1666 13.2021 21.5 12.7136 21.5H11.2867C10.7983 21.5 10.4149 21.1667 10.3338 20.7562L10.2547 20.356C9.82113 18.1617 7.50931 16.9082 5.40665 17.6165L5.0099 17.7501C4.55092 17.9047 4.06104 17.714 3.83671 17.3373L3.1233 16.1393C2.9058 15.7741 2.97959 15.3073 3.32398 15.0186L3.64185 14.7522C5.36782 13.3056 5.36781 10.6944 3.64185 9.24779L3.32398 8.98137C2.97959 8.69273 2.9058 8.2259 3.1233 7.86067L3.83674 6.66266C4.06106 6.28596 4.55093 6.09528 5.0099 6.24986L5.40676 6.38352C7.50938 7.09166 9.82112 5.83819 10.2547 3.64392L10.3338 3.24375Z"/>
              </svg>
            </button>
          </div>
        </div>
        <!-- Overlay y menú flotante de configuracion -->
        <div v-if="verOpciones" class="overlay" @click="verOpciones = false"></div>
        <div v-if="verOpciones" class="share-menu d-flex flex-column gap-2 fondo-principal mt-4 mt-lg-0 pt-3" style="max-width: 1400px; height: 88vh;">
          <div class="close-icon d-flex align-items-center" @click="verOpciones = false">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_429_11083)">
                <path d="M7 7.00006L17 17.0001M7 17.0001L17 7.00006" class="stroke-principal" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_429_11083">
                  <rect width="24" height="24" class="fill-principal"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div>
            <p class="m-0 fs-4 text-start ms-2">{{ $t('configuracion') }}</p>
            <div class="d-flex flex-row gap-2 justify-content-start align-items-start" style="border-bottom: 3px solid var(--fondo-secundario); max-width: 100vw;">
              <button type="button"
                class="btn-menu-2 texto-principal fondo-principal gap-2 d-flex"
                :class="{'active-btn': MenuVisible == 1}"
                @click="MenuVisible = 1"
              >
                <!-- <svg width="20" height="20" viewBox="0 -3.5 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Dribbble-Light-Preview" transform="translate(-99.000000, -760.000000)" class="fill-principal">
                      <g id="icons" transform="translate(56.000000, 160.000000)">
                        <path d="M53.5,603 C53.5,602.647 53.5756,602 53.6932,602 L43,602 L43,604 L53.6932,604 C53.5756,604 53.5,603.353 53.5,603 L53.5,603 Z M61.7068,602 C61.27315,601 60.1192,600 58.75,600 C57.01015,600 55.6,601.343 55.6,603 C55.6,604.657 57.01015,606 58.75,606 C60.1192,606 61.27315,605 61.7068,604 L64,604 L64,602 L61.7068,602 Z M53.5,611 C53.5,611.353 53.4244,611.686 53.3068,612 L64,612 L64,610 L53.3068,610 C53.4244,610 53.5,610.647 53.5,611 L53.5,611 Z M51.4,611 C51.4,612.657 49.98985,614 48.25,614 C46.8808,614 45.72685,613 45.2932,612 L43,612 L43,610 L45.2932,610 C45.72685,609 46.8808,608 48.25,608 C49.98985,608 51.4,609.343 51.4,611 L51.4,611 Z" id="settings-[#1389]"></path>
                      </g>
                    </g>
                  </g>
                </svg> -->
                <p class="m-0 fs-5">{{ $t('general') }}</p>
              </button>
              <button type="button"
                class="btn-menu-2 texto-principal fondo-principal gap-2 d-flex"
                :class="{'active-btn': MenuVisible == 2}"
                @click="MenuVisible = 2"
              >
                <!-- <svg width="25" height="25" class="stroke-principal" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.8179 4.54512L13.6275 4.27845C12.8298 3.16176 11.1702 3.16176 10.3725 4.27845L10.1821 4.54512C9.76092 5.13471 9.05384 5.45043 8.33373 5.37041L7.48471 5.27608C6.21088 5.13454 5.13454 6.21088 5.27608 7.48471L5.37041 8.33373C5.45043 9.05384 5.13471 9.76092 4.54512 10.1821L4.27845 10.3725C3.16176 11.1702 3.16176 12.8298 4.27845 13.6275L4.54512 13.8179C5.13471 14.2391 5.45043 14.9462 5.37041 15.6663L5.27608 16.5153C5.13454 17.7891 6.21088 18.8655 7.48471 18.7239L8.33373 18.6296C9.05384 18.5496 9.76092 18.8653 10.1821 19.4549L10.3725 19.7215C11.1702 20.8382 12.8298 20.8382 13.6275 19.7215L13.8179 19.4549C14.2391 18.8653 14.9462 18.5496 15.6663 18.6296L16.5153 18.7239C17.7891 18.8655 18.8655 17.7891 18.7239 16.5153L18.6296 15.6663C18.5496 14.9462 18.8653 14.2391 19.4549 13.8179L19.7215 13.6275C20.8382 12.8298 20.8382 11.1702 19.7215 10.3725L19.4549 10.1821C18.8653 9.76092 18.5496 9.05384 18.6296 8.33373L18.7239 7.48471C18.8655 6.21088 17.7891 5.13454 16.5153 5.27608L15.6663 5.37041C14.9462 5.45043 14.2391 5.13471 13.8179 4.54512Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 12L10.8189 13.8189V13.8189C10.9189 13.9189 11.0811 13.9189 11.1811 13.8189V13.8189L15 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg> -->
                <p class="m-0 fs-5">{{ $t('autorizaciones') }}</p>
              </button>
            </div>
          </div>

          <!-- General -->
          <div v-if="MenuVisible == 1" style="height: 100%; scrollbar-width: none;"
             class="pt-3 d-flex flex-column align-items-center overflow-y-auto px-3">
            <div v-if="form.ConAccesoRestringido != true" class="d-flex flex-column w-100 mb-3 align-items-start">
              <div class="d-flex flex-row me-4 gap-2 align-items-center"> 
                <svg width="22" height="22" viewBox="0 0 24 24" class="stroke-principal" :class="{'stroke-secundario': !form.FormPublicoATodos}" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <label for="anonimo-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.FormPublicoATodos}">{{ $t('formPublico') }}</label>
                <div class="form-check form-switch"> 
                  <input class="form-check-input" type="checkbox" id="anonimo-toggle" v-model="form.FormPublicoATodos">
                </div>
              </div>
              <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.FormPublicoATodos}">{{ $t('descripcionFormPublico') }}</small>
            </div>
            <hr v-if="form.ConAccesoRestringido != true" class="w-100 my-2" />

            <div class="d-flex flex-column w-100 mb-3 align-items-start">
              <div class="d-flex flex-row me-4 gap-2 align-items-center"> 
                <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                  <path class="stroke-principal" :class="{'stroke-secundario': !form.Anonimo}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 0 .211-.106a4 4 0 0 1 3.578 0L14 7.5m0 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Zm-2 6.303c5-3 5 3.5 9 1.767-1 4.233-6 4.233-9 1.233-3 3-8 3-9-1.233 4 1.733 4-4.767 9-1.767Z"/>
                </svg>
                <label for="anonimo-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.Anonimo}">{{ $t('anonimo') }}</label>
                <div class="form-check form-switch"> 
                  <input class="form-check-input" type="checkbox" id="anonimo-toggle" v-model="form.Anonimo">
                </div>
              </div>
              <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.Anonimo}">{{ $t('descripcionAnonimo') }}</small>
            </div>
            <hr class="w-100 my-2" />

            <div v-if="form.FormPublicoATodos != true" class="d-flex flex-column w-100 mb-3 align-items-start">
              <div class="d-flex flex-row me-4 gap-2 align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" class="stroke-principal" :class="{'stroke-secundario': !form.ConAccesoRestringido}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4"/>
                  <path d="M14 2v6h6"/>
                  <path d="M 3.501 18 L 6.501 15 L 3.501 12"/>
                  <path d="M 6.49 12.007 L 9.49 15.007 L 6.49 18.007" style="transform-box: fill-box; transform-origin: 50% 50%;" transform="matrix(-1, 0, 0, -1, 0, 0.000001)"/>
                </svg>
                <label for="acceso-restringido-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.ConAccesoRestringido}">{{ $t('accesoRestringido') }}</label>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="acceso-restringido-toggle" v-model="form.ConAccesoRestringido">
                </div>
              </div>
              <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.ConAccesoRestringido}">{{ $t('descripcionAccesoRestringido') }}</small>
            </div>
            <hr v-if="form.FormPublicoATodos != true" class="w-100 my-2" />

            <div class="d-flex flex-column w-100 mb-3">
              <div class="d-flex flex-column align-items-start">
                <div class="d-flex flex-row me-4 gap-2 align-items-center">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="stroke-principal" :class="{'stroke-secundario': !form.ConEdicionDeCompletado}" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <label for="edicion-completado-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.ConEdicionDeCompletado}">{{ $t('conEdicionDeCompletado') }}</label>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="edicion-completado-toggle" v-model="form.ConEdicionDeCompletado">
                  </div>
                </div>
                <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.ConEdicionDeCompletado}">{{ $t('descripcionEdicionCompletado') }}</small>
              </div>
              <div v-if="form.ConEdicionDeCompletado" class="d-flex align-items-center gap-2 mt-3">
                <div class="select-wrapper">
                  <select v-model="form.AQuienEdita" class="form-select border-0 bg-goethe-accent-claro texto-principal" required>
                    <option value="Las Propias">{{ $t('laspropias') }}</option>
                    <option value="Todos">{{ $t('todos') }}</option>
                  </select>
                  <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                  </svg>
                </div>
                <div class="tooltip-container d-flex justify-content-center align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12" y2="8"></line>
                  </svg>
                  <span class="tooltip-text-left text-left" style="max-width: 50vw; width: 250px;">
                    <p class="m-0 fs-8 texto-secundario">{{ $t('queRespuestasPuedenEditar') + ': ' + $t((form.AQuienEdita || '').replace(/\s+/g, '').toLowerCase()) }}</p>
                  </span>
                </div>
              </div>
            </div>
            <hr class="w-100 my-2" />

            <div class="d-flex flex-column w-100 mb-3 align-items-start">
              <div class="d-flex flex-row me-4 gap-2 align-items-center">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4L9.87868 9.87868M20 20L14.1213 14.1213M9.87868 9.87868C9.33579 10.4216 9 11.1716 9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M9.87868 9.87868L14.1213 14.1213M6.76821 6.76821C4.72843 8.09899 2.96378 10.026 2 11.9998C3.74646 15.5764 8.12201 19 11.9998 19C13.7376 19 15.5753 18.3124 17.2317 17.2317M9.76138 5.34717C10.5114 5.12316 11.2649 5 12.0005 5C15.8782 5 20.2531 8.42398 22 12.0002C21.448 13.1302 20.6336 14.2449 19.6554 15.2412" class="stroke-principal" :class="{'stroke-secundario': !form.ConVisualizacionRestringida}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <label for="visualizacion-restringida-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.ConVisualizacionRestringida}">{{ $t('conVisualizacionRestringida') }}</label>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="visualizacion-restringida-toggle" v-model="form.ConVisualizacionRestringida">
                </div>
              </div>
              <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.ConVisualizacionRestringida}">{{ $t('descripcionVisualizacionRestringida') }}</small>
            </div>
            <hr v-if="!form.ConAccesoRestringido" class="w-100 my-2" />

            <div v-if="!form.ConAccesoRestringido" class="d-flex flex-column w-100 mb-3">
              <div class="d-flex flex-column align-items-start">
                <div class="d-flex flex-row me-4 gap-2 align-items-center">
                  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" class="stroke-principal icon line-color" :class="{'stroke-secundario': !form.DarAccesoAlCompletar}" data-name="Line Color">
                    <g class="layer">
                      <path d="m18.22,17.99l4,0m-2,-2l0,4" fill="#000" id="secondary" stroke=" rgb(44, 169, 188)" stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                      <path d="m16.15,14.09a4.71,4.71 0 0 0 -1,-0.1l-6,0a5,5 0 0 0 -5,5l0,1s2,2 8,2a22,22 0 0 0 3,-0.19c0.35,0 0.69,-0.1 1,-0.17" fill=" none" id="primary"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                      <path d="m7.08,10.67a5,5 0 0 0 -5,5l0,1" fill=" none" id="svg_1"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                      <path d="m12.36,13.47c-2.71,0 -4.91,-2.2 -4.91,-4.92c0,-2.71 2.2,-4.91 4.91,-4.91c2.72,0 4.92,2.2 4.92,4.91c0,2.72 -2.2,4.92 -4.92,4.92z" fill="none" id="svg_9" opacity="undefined"  stroke-width="2" transform="matrix(1 0 0 1 0 0)"/>
                      <line fill="none" id="svg_11"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2" x1="2.1" x2="4.01" y1="17.06" y2="17.18"/>
                      <path d="m6.46,9.28c-1.26,0.03 -2.88,-1.57 -2.88,-3.57c0,-1.99 1.62,-3.61 3.61,-3.61c2,0 3.47,1.8 3.07,1.98c-0.39,0.18 -1.2,0.63 -1.72,1.23c-0.52,0.6 -0.72,1.06 -1,2.09c-0.27,1.02 0.17,1.86 -1.09,1.88z" fill="none" id="svg_3" opacity="undefined"  stroke-width="2"/>
                    </g>
                  </svg>
                  <label for="dar-acceso-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.DarAccesoAlCompletar}">{{ $t('darAccesoAlCompletar') }}</label>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="dar-acceso-toggle" v-model="form.DarAccesoAlCompletar">
                  </div>
                </div>
                <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.DarAccesoAlCompletar}">{{ $t('descripcionDarAccesoAlCompletar') }}</small>
              </div>
              <div v-if="form.DarAccesoAlCompletar" class="d-flex mt-3">
                <div class="select-wrapper">
                  <select v-model="form.TipoAccesoADar" class="form-select border-0 bg-goethe-accent-claro texto-principal" style="background-color: #f3cb7a;" required>
                    <option value="Completador">{{ $t('completador') }}</option>
                    <option v-if="form.ConRespuesta" value="Respondedor">{{ $t('respondedor') }}</option>
                    <option value="Lector">{{ $t('lector') }}</option>
                    <option value="Editor">{{ $t('editor') }}</option>
                  </select>
                  <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                  </svg>
                </div>
              </div>
            </div>
            <hr class="w-100 my-2" />

            <div class="d-flex flex-column w-100 mb-3">
              <div class="d-flex flex-column align-items-start">
                <div class="d-flex flex-row me-4 gap-2 align-items-center">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="stroke-principal" :class="{'stroke-secundario': !form.ConRespuesta}" xmlns="http://www.w3.org/2000/svg">
                    <path d="M 9.364 12.06 L 17.595 12.06 M 9.364 15.353 L 13.48 15.353 M 20.888 21.114 L 18.152 19.746 C 17.944 19.643 17.84 19.591 17.731 19.555 C 17.635 19.522 17.536 19.499 17.435 19.485 C 17.321 19.468 17.205 19.468 16.973 19.468 L 8.706 19.468 C 7.784 19.468 7.323 19.468 6.971 19.289 C 6.661 19.132 6.409 18.88 6.251 18.569 C 6.072 18.217 6.072 17.756 6.072 16.834 L 6.072 10.579 C 6.072 9.657 6.072 9.196 6.251 8.844 C 6.409 8.534 6.661 8.282 6.971 8.124 C 7.323 7.945 7.784 7.945 8.706 7.945 L 18.254 7.945 C 19.176 7.945 19.636 7.945 19.989 8.124 C 20.298 8.282 20.55 8.534 20.708 8.844 C 20.888 9.196 20.888 9.657 20.888 10.579 L 20.888 21.114 Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M 4.858 7.257 L 13.089 7.257 M 4.858 10.55 L 5.993 10.55 M 16.352 7.88 L 7.593 7.866 C 7.385 7.763 6.5 8.346 6.359 8.549 C 6.091 8.934 6.093 9.535 6.064 10.105 C 6.05 10.378 6.044 14.304 6.053 14.695 L 4.2 14.665 C 3.278 14.665 2.817 14.665 2.465 14.486 C 2.155 14.329 1.903 14.077 1.745 13.766 C 1.566 13.414 1.566 12.953 1.566 12.031 L 1.566 5.776 C 1.566 4.854 1.566 4.393 1.745 4.041 C 1.903 3.731 2.155 3.479 2.465 3.321 C 2.817 3.142 3.278 3.142 4.2 3.142 L 13.748 3.142 C 14.67 3.142 15.13 3.142 15.483 3.321 C 15.792 3.479 16.044 3.731 16.202 4.041 C 16.382 4.393 16.382 4.854 16.382 5.776 L 16.352 7.88 Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <label for="con-respuesta-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.ConRespuesta}">{{ $t('conRespuesta') }}</label>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="con-respuesta-toggle" v-model="form.ConRespuesta">
                  </div>
                </div>
                <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.ConRespuesta}">{{ $t('descripcionConRespuesta') }}</small>
              </div>
              <div v-if="form.ConRespuesta && !form.Anonimo" class="d-flex flex-row gap-2 align-items-center mt-3">
                <div class="select-wrapper">
                  <select v-model="form.AQuienesResponden" class="form-select d-flex border-0 bg-goethe-accent-claro texto-principal" required>
                    <option value="Subordinados">{{ $t('subordinados') }}</option>
                    <option value="Todos">{{ $t('todos') }}</option>
                  </select>
                  <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                  </svg>
                </div>
                <div class="tooltip-container d-flex justify-content-center align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12" y2="8"></line>
                  </svg>
                  <span class="tooltip-text-left text-left" style="max-width: 50vw; width: 250px;">
                    <p class="m-0 fs-8 texto-secundario">{{ $t('quienesLesApareceParaResponder') + ' ' + $t(form.AQuienesResponden ?? '') }}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Autorizaciones -->
          <div v-if="MenuVisible == 2" style="height: 100%; scrollbar-width: none;"
             class="pt-3 d-flex flex-column align-items-center overflow-y-auto px-3">
            <div class="d-flex flex-column w-100 mb-3 align-items-start">
              <div class="d-flex flex-row me-4 gap-2 align-items-center">
                <svg fill="none" width="25" height="25" class="stroke-principal icon line-color" :class="{'stroke-secundario': !form.ConAutorizaciones}" viewBox="0 0 24 24" id="done-music-collection" data-name="Line Color" xmlns="http://www.w3.org/2000/svg">
                  <polyline id="secondary" points="7 9.63 9.25 11.88 13 8.13" style="fill: none;  stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></polyline>
                  <rect id="primary" x="3" y="3" width="14" height="14" rx="1" style="fill: none;  stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></rect>
                  <path id="primary-2" data-name="primary" d="M7,21H17a4,4,0,0,0,4-4V5" style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></path>
                </svg>
                <label for="autorizaciones-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.ConAutorizaciones}">{{ $t('conAutorizaciones') }}</label>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="autorizaciones-toggle" v-model="form.ConAutorizaciones">
                </div>
              </div>
              <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.ConAutorizaciones}">{{ $t('descripcionAutorizaciones') }}</small>
            </div>
            
            <!-- Listas Autorizaciones -->
            <div v-if="form.ConAutorizaciones" class="w-100">
              <hr class="w-100 my-2" />
              <div class="d-flex flex-column w-100 mb-3 align-items-start">
                <div class="d-flex flex-row me-4 gap-2 align-items-center">
                  <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal" :class="{'stroke-secundario': !form.OcultarHistorialAutorizaciones}">
                    <path id="Vector" d="M4 17H10M4 12H13M18 11V19M18 19L21 16M18 19L15 16M4 7H16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <label for="autorizaciones-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.AutorizarDesordenado}">{{ $t('autorizarDesordenado') }}</label>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="autorizaciones-toggle" v-model="form.AutorizarDesordenado">
                  </div>
                </div>
                <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.AutorizarDesordenado}">{{ $t('descripcionAutorizarDesordenado') }}</small>
              </div>
              <hr class="w-100 my-2" />
              <div class="d-flex flex-column w-100 mb-3 align-items-start">
                <div class="d-flex flex-row me-4 gap-2 align-items-center">
                  <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal" :class="{'stroke-secundario': !form.OcultarHistorialAutorizaciones}">
                    <path d="M5.52786 16.7023C6.6602 18.2608 8.3169 19.3584 10.1936 19.7934C12.0703 20.2284 14.0409 19.9716 15.7434 19.0701C17.446 18.1687 18.766 16.6832 19.4611 14.8865C20.1562 13.0898 20.1796 11.1027 19.527 9.29011C18.8745 7.47756 17.5898 5.96135 15.909 5.02005C14.2282 4.07875 12.2641 3.77558 10.3777 4.16623C8.49129 4.55689 6.80919 5.61514 5.64045 7.14656C4.47171 8.67797 3.89482 10.5797 4.01579 12.5023M4.01579 12.5023L2.51579 11.0023M4.01579 12.5023L5.51579 11.0023" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 8V12L15 15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <label for="autorizaciones-toggle" class="form-label mb-0 fs-5" :class="{'texto-secundario':!form.OcultarHistorialAutorizaciones}">{{ $t('ocultarHistorialAutorizaciones') }}</label>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="autorizaciones-toggle" v-model="form.OcultarHistorialAutorizaciones">
                  </div>
                </div>
                <small class="texto-secundario text-start mt-2" :class="{'texto-terciario':!form.OcultarHistorialAutorizaciones}">{{ $t('descripcionOcultarHistorialAutorizaciones') }}</small>
              </div>
              <hr class="w-100 my-2" />

              <div class="w-100 text-start d-flex flex-column gap-3 pb-3">
                <div class="d-flex flex-row gap-2 align-items-center">
                  <svg width="25" height="20" viewBox="0 0 20 20" version="1.1" class="fill-principal" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Dribbble-Light-Preview" transform="translate(-60.000000, -7959.000000)">
                      <g id="icons" transform="translate(56.000000, 160.000000)">
                        <path d="M22,7816 C22,7816.552 21.552,7817 21,7817 L7,7817 C6.448,7817 6,7816.552 6,7816 L6,7802 C6,7801.448 6.448,7801 7,7801 L9,7801 C9.552,7801 10,7801.448 10,7802 L10,7805 C10,7806.105 10.896,7807 12,7807 L15,7807 C15.552,7807 16,7807.448 16,7808 L16,7811 C16,7812.105 16.896,7813 18,7813 L21,7813 C21.552,7813 22,7813.448 22,7814 L22,7816 Z M22,7811 L19,7811 C18.448,7811 18,7810.552 18,7810 L18,7807 C18,7805.895 17.104,7805 16,7805 L12,7805 L12,7801 C12,7799.895 11.104,7799 10,7799 L6,7799 C4.896,7799 4,7799.895 4,7801 L4,7817 C4,7818.105 4.896,7819 6,7819 L22,7819 C23.104,7819 24,7818.105 24,7817 L24,7813 C24,7811.895 23.104,7811 22,7811 L22,7811 Z" id="stairs-[#58]"></path>
                      </g>
                    </g>
                  </svg>
                  <p class="fs-5 m-0">{{$t('pasosDeAutorizacion')}}:</p>
                </div>
                <div v-for="(nivel, index) in form.AutorizadoresNivel" :key="nivel?.NroOrden" class="fondo-secundario border border-0 rounded-4 sombra">
                  <div class="d-flex gap-2 fondo-terciario rounded-top-4 w-100 p-2 px-3">
                    <p class="m-0 texto-principal fs-5">
                      {{ nivel.NroOrden + "° "+ $t('paso') }}
                    </p>
                    <button type="button" class="btn btn-sm fs-8 p-0" @click="removeNivel(index)"><!--  -->
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal" style=" margin-bottom: 2px;">
                        <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                  <div class="p-2 px-3">
                    <!-- Celda con nombre -->
                    <div class="d-flex flex-wrap align-items-center justify-content-start gap-2 px-3 pt-2 pb-2">
                      <p class="m-0 mt-2 text-start d-inline-block">{{ $t('estados')}}:</p>
                      <div v-for="(estado) in nivel.Estados" :key="estado.IdAutorizacionEstado" class="d-inline-block">
                        <div v-if="estado" class="d-inline-flex texto-principal px-2 border border-0 rounded-4 align-items-center justify-content-center gap-1"
                        :class="{ 'select-aprobado': estado.Autorizado === true,
                                  'select-desaprobado': estado.Autorizado === false,
                                  'select-nada': estado.Autorizado === null}">
                          <textarea class="form-control border-0 bg-transparent shadow-none fw-bold p-2" id="nombreFormulario" v-model="estado.EstadoNombre" rows="1" style="width: 120px; resize: none;" maxlength="50" required></textarea>
                          <!-- Divider Vertical -->
                          <div class="col-12" style="border-right: 1px solid #8F9094; height: 30px; width:1px"></div>
                          <select v-model="estado.Autorizado" class="d-inline-block form-select border-0 texto-principal" style="width: 90px;"
                            :class="{ 'select-aprobado': estado.Autorizado === true,
                                    'select-desaprobado': estado.Autorizado === false,
                                    'select-nada': estado.Autorizado === null}" required>
                            <option :value=true>true</option>
                            <option :value=false>false</option>
                            <option :value=null>null</option>
                          </select>
                          <button type="button" class="btn btn-sm fs-8 p-0" @click="nivel.Estados = nivel.Estados.filter(e => e.IdAutorizacionEstado !== estado.IdAutorizacionEstado)"><!--  -->
                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal" style=" margin-bottom: 2px;">
                              <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <button type="button" class="btn text-start texto-principal fs-6 bg-goethe-accent-claro p-2 border border-0 rounded-4"
                          @click="agregarEstado(nivel)">
                        <svg style="margin-bottom: 2px" class="mx-1" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 12H18M12 6V18" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </div>
                    <div class="d-flex flex-wrap align-items-start px-3 p-1 w-100 gap-2">
                      <div class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-3"
                          :class="{ 'checkbox-custom-pill-2-checked': nivel.EnviarEmailCambioEstado, 'checkbox-custom-pill-2': !nivel.EnviarEmailCambioEstado}"
                          style="cursor: pointer; min-height: 35px;"
                          @click="nivel.EnviarEmailCambioEstado = !nivel.EnviarEmailCambioEstado">
                        <input class="checkbox-custom-2" type="checkbox" role="switch" v-model="nivel.EnviarEmailCambioEstado" >
                        <span>{{ $t('enviarEmailCambioEstado') }}</span>
                      </div>
                      <div class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-3"
                          :class="{ 'checkbox-custom-pill-2-checked': nivel.EnviarEmailAAutorizadores, 'checkbox-custom-pill-2': !nivel.EnviarEmailAAutorizadores}"
                          style="cursor: pointer; min-height: 35px;"
                          @click="nivel.EnviarEmailAAutorizadores = !nivel.EnviarEmailAAutorizadores">
                        <input class="checkbox-custom-2" type="checkbox" role="switch" v-model="nivel.EnviarEmailAAutorizadores" >
                        <span>{{ $t('enviarEmailAAutorizadores') }}</span>
                      </div>
                      <div class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-3"
                          :class="{ 'checkbox-custom-pill-2-checked': nivel.EnviarEmailResumenDiario, 'checkbox-custom-pill-2': !nivel.EnviarEmailResumenDiario}"
                          style="cursor: pointer; min-height: 35px;"
                          @click="nivel.EnviarEmailResumenDiario = !nivel.EnviarEmailResumenDiario">
                        <input class="checkbox-custom-2" type="checkbox" role="switch" v-model="nivel.EnviarEmailResumenDiario" >
                        <span>{{ $t('enviarEmailResumenDiario') }}</span>
                      </div>
                      <div class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-3"
                          :class="{ 'checkbox-custom-pill-2-checked': nivel.NoAprobarAutomaticamente, 'checkbox-custom-pill-2': !nivel.NoAprobarAutomaticamente}"
                          style="cursor: pointer; min-height: 35px;"
                          @click="nivel.NoAprobarAutomaticamente = !nivel.NoAprobarAutomaticamente">
                        <input class="checkbox-custom-2" type="checkbox" role="switch" v-model="nivel.NoAprobarAutomaticamente" >
                        <span>{{ $t('noAprobarAutomaticamente') }}</span>
                      </div>
                      <div v-if="nivel.TipoPermiso != 'Todos'" class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-3"
                          :class="{ 'checkbox-custom-pill-2-checked': nivel.SePuedenAutoAutorizar, 'checkbox-custom-pill-2': !nivel.SePuedenAutoAutorizar}"
                          style="cursor: pointer; min-height: 35px;"
                          @click="nivel.SePuedenAutoAutorizar = !nivel.SePuedenAutoAutorizar">
                        <input class="checkbox-custom-2" type="checkbox" role="switch" v-model="nivel.SePuedenAutoAutorizar" >
                        <span>{{ $t('sePuedenAutoAutorizar') }}</span>
                      </div>
                    </div>
                    <div class="px-3 pt-2 pb-2 d-flex align-items-center gap-2">
                      <select v-model="nivel.TipoPermiso" class="form-select border-0 bg-goethe-accent-claro texto-principal" required>
                        <option v-for="(grupo, indexgrupo) in gruposDisponiblesPermisos" :key="indexgrupo" :value="grupo.nombre">{{ grupo.nombre }}</option>
                        <option value="Todos">{{ $t('todos') }}</option><!-- Indica que los autorizados pueden responder a todos -->
                      </select>
                      <div class="tooltip-container d-flex justify-content-center align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" y1="16" x2="12" y2="12"></line>
                          <line x1="12" y1="8" x2="12" y2="8"></line>
                        </svg>
                        <span class="tooltip-text-left text-left bg-goethe-accent-claro-2 texto-principal border-goethe-accent-claro-2" style="max-width: 50vw; width: 250px;">
                          <p class="m-0 fs-8 texto-secundario">{{ $t('aQuienesAutorizan') }}</p>
                        </span>
                      </div>
                    </div>
                    <div class="px-3 py-1 d-flex flex-wrap align-items-start gap-2">
                      <div v-for="(personas, i) in nivel.Autorizadores" :key="personas.IdAutorizadores"
                        class="border-0" :class="{'borde-arcoiris': personas.AutorizadorGeneral == true}"
                        @click="personas.AutorizadorGeneral = !personas.AutorizadorGeneral">

                        <div class="d-inline-flex texto-principal p-2 ps-3 rounded-4"
                        :class="{'bg-goethe-accent-claro': personas.Inhabilitado != true,
                                  'bg-dark-subtle': personas.Inhabilitado == true}">
                          {{ personas.Persona?.Apellido }},
                          {{ personas.Persona?.Nombre }}
                          <button v-if="!personas.Inhabilitado" type="button" class="btn btn-sm mx-1 mb-1 fs-8 p-0" @click.stop="borrarPersona(index, i, personas.IdAutorizadores);">
                              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                                  <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </button>
                          <button v-if="personas.Inhabilitado" type="button" class="btn btn-sm mx-1 fs-8 p-0" @click="personas.Inhabilitado = false" style="margin-bottom: 2px;">
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </button>
                          
                          <div v-if="personas.AutorizadorGeneral == true" class="tooltip-container">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="16" x2="12" y2="12"></line>
                                <line x1="12" y1="8" x2="12" y2="8"></line>
                            </svg>
                            <span class="tooltip-text-right text-left" style="max-width: 50vw; width: 350px;">
                                <p class="m-0 fs-8">{{ $t('autorizadorGeneralDescr') }}</p>
                            </span>
                          </div>
                        </div>
                      </div>
                      
  
                      <button type="button" class="btn text-start texto-principal fs-6 bg-goethe-accent-claro p-2 px-3 border border-0 rounded-4" 
                          @click="nivel.ShowAddAutorizador = true">
                        <svg style="margin-bottom: 2px;" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 12H18M12 6V18" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
  
                      <div v-if="nivel.ShowAddAutorizador" class="position-relative d-flex flex-column gap-2">
                        <!-- Selector de tipo de agregado -->
                        <div class="d-flex gap-2 align-items-center">
                          <label class="form-label m-0">{{ $t('agregarPor') }}:</label>
                          <select v-model="nivel.modoAgregar" class="form-select w-auto">
                            <option value="persona">{{ $t('personaEspecifica') }}</option>
                            <option value="grupo">{{ $t('grupo') }}</option>
                          </select>
                        </div>
  
                        <!-- Modo Persona -->
                        <div v-if="nivel.modoAgregar === 'persona'" class="d-flex flex-row gap-2 align-items-center position-relative">
                          <input type="text" v-model="nivel.SearchQueryAutorizadores" :placeholder="$t('buscarPersona') + '...'" class="form-control w-100" @input="filterPersonasAutorizadores(nivel)" />
                          <ul v-if="nivel.FilteredPersonasAutorizadores?.length > 0" class="list-group position-absolute" style="z-index: 1000; width: 100%; top: 100%;">
                            <li v-for="evaluado in nivel.FilteredPersonasAutorizadores" :key="evaluado?.IdPersona" class="list-group-item list-group-item-action text-start" @click="selectPersonaAutorizadores(evaluado, nivel)" style="cursor: pointer;">
                              {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
                            </li>
                          </ul>
                          <button type="button" class="btn btn-primary fs-6" @click="agregarPersonaAutorizadores(nivel.NroOrden, nivel)">
                            {{ $t('agregar') }}
                          </button>
                          <button type="button" class="btn btn-secondary fs-6" @click="cancelarPersonaAutorizadores(nivel, index)">
                            {{ $t('cancelar') }}
                          </button>
                        </div>
  
                        <!-- Modo Grupo (puedes personalizar esto con tus propios grupos) -->
                        <div v-else-if="nivel.modoAgregar === 'grupo'" class="d-flex flex-row gap-2 align-items-center">
                          <select v-model="grupoSeleccionado" class="form-select w-100">
                            <option v-for="grupo in gruposDisponibles" :key="grupo.id" :value="grupo.id">
                              {{ grupo.nombre }}
                            </option>
                          </select>
                          <button type="button" class="btn btn-primary fs-6" @click="agregarGrupoAutorizadores(nivel)">
                            {{ $t('agregar') }}
                          </button>
                          <button type="button" class="btn btn-secondary fs-6" @click="cancelarPersonaAutorizadores(nivel, index)">
                            {{ $t('cancelar') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button type="button" class="btn d-flex texto-principal fs-6 sombra fondo-secundario p-3 px-4 border border-0 rounded-4 align-items-center justify-content-center gap-2" 
                    @click="agregarNivel">
                  <svg width="15" height="15" viewBox="5 5 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12H18M12 6V18" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <p class="m-0 d-inline-block fs-5">{{ $t('agregarPaso') }}</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contenedor de la imagen o icono -->
      <div class="d-flex justify-content-center align-items-center bg-light card-img-top rounded-4 position-relative" style="height: 200px; cursor: pointer;" @click="selectImage">
        <!-- Mostrar la imagen si ya está cargada -->
        <img v-if="form.PortadaUrl" :src="form.PortadaUrl" alt="Imagen seleccionada" class="rounded-4 w-100 h-100 object-fit-cover">
        
        <!-- Mostrar el icono si no hay imagen -->
        <i v-else class="bi bi-image fs-1 texto-secundario"></i>

        <!-- Input oculto para subir la imagen -->
        <input type="file" ref="fileInput" @change="handleFileUpload" accept="image/*" class="d-none">

        <!-- Loader sobre todo -->
        <div v-if="loadingFile" 
            class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75">
          <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
        </div>
      </div>
      <!-- Campos del Formulario -->
      <div>
        <label for="nombreFormulario">{{ $t('nombreFormulario') }}</label>
        <textarea class="form-control sombra" id="nombreFormulario" v-model="form.NombreFormulario" rows="1" oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'" style="height: 38px; resize: none;" maxlength="200" required></textarea>
      </div>

      <div>
        <label for="descripcion">{{ $t('descripcion') }}</label>
        <textarea id="descripcion" v-model="form.Descripcion" class="form-control sombra" style="height: 120px; resize: none;" maxlength="1000" required></textarea>
        <div class="mt-2 text-end">
          <span>{{ form.Descripcion?.length }}/1000 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
        </div>
      </div>
      
      <!-- Divider -->
      <div class="col-12 my-2 borde-linea" style="height: 1px"></div>
      
      <!-- Observaciones -->
      <label>{{ $t('observaciones') }}:</label>
      <div v-for="(observacion, indexObs) in form.Observacions" :key="indexObs" class="p-3 border fondo-secundario sombra-sm rounded d-flex flex-row gap-3" :class="{ 'border-goethe-accent-claro-3': observacion.Obligatorio, 'borde-secundario': !observacion.Obligatorio  }">
        <div class="d-flex flex-column">
          <svg width="20" height="20" viewBox="4 4 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" @click="moveUp(indexObs, null)" style="cursor: pointer">
            <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#999" transform="scale(1, -1) translate(0, -24)"/>
          </svg>
          <h3 class="text-center mb-1 texto-secundario">{{ observacion.NroOrden }}</h3>
          <svg width="20" height="20" viewBox="4 4 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" @click="moveDown(indexObs, null)" style="cursor: pointer">
            <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#999"/>
          </svg>
        </div>

        <div class="w-100">
          <div class="mb-1 d-flex flex-row gap-2 justify-contents-center align-items-center">
            <textarea
              class="form-control sombra-sm"
              id="exampleTextarea"
              v-model="observacion.NombreObservacion"
              :placeholder="$t('ingreseTituloObservacion')"
              rows="1"
              oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'"
              style="height: 38px; resize: none;"
              maxlength="200" required
            ></textarea>
            <div class="select-wrapper" style="width: 30%;">
              <select v-model="observacion.IdTipoObservacion" class="form-select fondo-terciario texto-principal borde-terciario sombra-sm">
                <option v-for="tipo in tiposObservacion" :key="tipo.IdTipoObservacion" :value="tipo.IdTipoObservacion">
                  {{ $t(`${ tipo.tipoObservacion.replace(/\s+/g, '')}`) }}
                </option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
            </div>
          </div>

          <div>
            <label for="descripcion">{{ $t('descripcion') }}</label>
            <textarea id="descripcion" v-model="observacion.Descripcion" class="form-control sombra-sm" style="height: 80px; resize: none;" maxlength="1000"></textarea>
            <div class="text-end">
              <span>{{ observacion.Descripcion?.length }}/1000 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
            </div>
          </div>
          <!-- Divider -->
          <div class="col-12 my-3 borde-linea" style="height: 1px"></div>

          <!-- Mostrar campos diferentes según el tipo de observación -->
          <div v-if="observacion.IdTipoObservacion === '6A89FB8F-18B7-45B7-8015-AB1445BBAD4A'.toLowerCase()"><!--Texto Corto-->
            <textarea
              class="form-control sombra-sm"
              id="exampleTextarea"
              placeholder="Texto corto"
              rows="1"
              oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'"
              style="height: 38px; resize: none;" disabled
            ></textarea>
          </div>

          <div v-if="observacion.IdTipoObservacion === '9d19533b-3d29-4ff3-9be4-0ec902db6191'.toLowerCase()"><!--Fecha-->
            <input type="date" class="form-control sombra-sm" id="fecha" placeholder="Selecciona una fecha">
          </div>

          <div v-if="observacion.IdTipoObservacion === '56cdebd4-89e8-4bb2-a26e-8f366c3f4159'.toLowerCase()"><!--Hora-->
            <input type="time" class="form-control sombra-sm" id="hora" placeholder="Selecciona una hora">
          </div>

          <div v-if="observacion.IdTipoObservacion === '4BA48D01-AFEB-4D81-87D2-67FA07187CB5'.toLowerCase()" class="d-flex flex-column gap-2"><!--Listas-->
            <!-- Items de Observación -->
            <label v-for="(item, indexItem) in observacion.ItemsObservacions" :key="indexItem" class="d-flex flex-row m-0 ms-1 align-items-center gap-1 text-wrap">
              <div class="d-flex flex-column">
                <svg width="10" height="10" viewBox="4 4 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" @click="moveUp(indexItem, observacion)" style="cursor: pointer">
                  <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#999" transform="scale(1, -1) translate(0, -24)"/>
                </svg>
                <p class="text-center mb-1 texto-secundario">{{ item.NroOrden }}</p>
                <svg width="10" height="10" viewBox="4 4 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" @click="moveDown(indexItem, observacion)" style="cursor: pointer">
                  <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#999"/>
                </svg>
              </div>
              <input type="radio" :value="indexItem" v-model="observacion.OpcionSeleccionada" class="text-wrap sombra-sm" disabled/>
              {{ item.NombreItem }}
              <button type="button" class="btn btn-sm ms-2 fs-8" @click="removeItem(indexObs, indexItem)">
                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-secundario">
                  <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </label>

            <!-- Mostrar el campo de texto y botones de agregar y cancelar -->
            <div v-if="observacion.ShowAddItem" class="d-flex flex-row gap-2 align-items-center">
              <!-- <input type="text" v-model="observacion.newItemName" class="form-control fs-6" placeholder="Ingrese el nuevo item" maxlength="200"/> -->
              <textarea class="form-control fs-6 sombra-sm" id="nombreFormulario" v-model="observacion.NewItemName" rows="1" placeholder="Ingrese el nuevo item" oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'" style="height: 38px; resize: none;" maxlength="200" required></textarea>
              <button type="button" class="btn btn-primary fs-6 sombra-sm" @click="confirmAddItem(indexObs)">{{ $t('agregar') }}</button>
              <button type="button" class="btn btn-secondary fs-6 sombra-sm" @click="cancelAddItem(indexObs)">{{ $t('cancelar') }}</button>
            </div>
            <!-- Botón Agregar Item -->
            <button type="button" class="btn text-start texto-secundario fs-6 p-1" style="width: 150px;" @click="toggleAddItem(indexObs)">
              <svg class="mb-1" width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 12H18M12 6V18" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ $t('agregarItem') }}
            </button>
          </div>

          <div v-if="observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()" class="d-flex flex-column gap-2"><!--Rango-->
            <div class="d-flex flex-row gap-2 align-items-center">
              <label for="minRangeInput" class="m-0">{{ $t('min') }}:</label>
              <input type="number" id="minRangeInput" v-model="observacion.ItemsObservacions.find(i => i.NombreItem === 'Minimo').ValorDeRango" class="form-control sombra-sm" />

              <label for="maxRangeInput" class="m-0">{{ $t('max') }}:</label>
              <input type="number" id="maxRangeInput" v-model="observacion.ItemsObservacions.find(i => i.NombreItem === 'Maxima').ValorDeRango" class="form-control sombra-sm" />

              <label for="stepValueInput" class="m-0">{{ $t('step') }}:</label>
              <input type="number" id="stepValueInput" v-model="observacion.ItemsObservacions.find(i => i.NombreItem === 'StepValue').ValorDeRango" step="0.1" class="form-control sombra-sm" />
            </div>

            <span>{{ currentValue }}</span>
            
            <div class="d-flex justify-content-between gap-2">
              <!-- Valor mínimo -->
              <span>{{ observacion.ItemsObservacions.find(i => i.NombreItem === 'Minimo').ValorDeRango }}</span>
              
              <!-- Slider de rango -->
              <input type="range" class="form-range" :min="observacion.ItemsObservacions.find(i => i.NombreItem === 'Minimo').ValorDeRango" :max="observacion.ItemsObservacions.find(i => i.NombreItem === 'Maxima').ValorDeRango" :step="observacion.ItemsObservacions.find(i => i.NombreItem === 'StepValue').ValorDeRango" v-model="currentValue" id="customRange3" disabled/>
              
              <!-- Valor máximo -->
              <span>{{ observacion.ItemsObservacions.find(i => i.NombreItem === 'Maxima').ValorDeRango }}</span>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === 'B3903AB7-FC85-45C3-AD59-7943330DB389'.toLowerCase()" class="d-flex flex-column gap-4"><!--Numero-->
            <div class="input-group mb-3">
              <span class="p-2 rounded-start-2 sombra-sm fondo-terciario texto-principal border-end border-2 borde-principal" id="basic-addon1">Valor</span>
              <input class="form-control sombra-sm" type="number" style="max-width: 100px;" disabled/>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === 'e42de6bc-9113-4ba6-8818-49fa8a2c0c6f'.toLowerCase()"><!--Condicion Observable-->
            <div class="btn-group w-100 bg-goethe-accent-claro-3" role="group" aria-label="Basic radio toggle button group" style="height: 50px;">

              <input type="radio" class="btn-check sombra-sm" :name="'observacion_' + indexObs" id="btnradio1" autocomplete="off" disabled>
              <label class="btn border-end border-start border-goethe-accent-claro d-flex align-items-center justify-content-center texto-principal" for="btnradio1">{{ $t('Si') }}</label>

              <input type="radio" class="btn-check sombra-sm" :name="'observacion_' + indexObs" id="btnradio2" autocomplete="off" disabled>
              <label class="btn border-end border-start border-goethe-accent-claro d-flex align-items-center justify-content-center texto-principal" for="btnradio2">{{ $t('No') }}</label>

              <input type="radio" class="btn-check sombra-sm" :name="'observacion_' + indexObs" id="btnradio3" autocomplete="off" disabled>
              <label class="btn border-end border-start border-goethe-accent-claro d-flex align-items-center justify-content-center texto-principal" for="btnradio3">{{ $t('No Observable') }}</label>

            </div>
          </div>
        
          <div v-if="observacion.IdTipoObservacion === 'bb1c6568-f8ea-42bc-9133-375f86fa2415'.toLowerCase()"><!--Archivo-->
            <label>{{ $t('subirArchivo') }}</label>
            <input 
              type="file" 
              class="form-control sombra-sm" 
              :id="'archivo-' + indexObs" 
              accept=".pdf,.doc,.docx,.jpg,.png,.txt,.zip" disabled/>
            <small class="texto-secundario text-start">{{ $t('tamanoMaximo') }}: 50MB</small>
            <div v-if="observacion.Archivo && observacion.Archivo.Nombre" class="mt-2">
              <p class="m-0">{{ $t('archivoSeleccionado') }}: {{ observacion.Archivo.Nombre }}</p>
            </div>
          </div>
          
          <div v-if="observacion.IdTipoObservacion === '989bec4b-779d-41b0-8b28-1f1487b59ded'.toLowerCase()" class="d-flex flex-column gap-2 w-100"><!--Evaluado-->
            <div>
              <label >{{ $t('evaluado') }} {{ $t('seleccionarTipoATraer') }}:</label>
              <div class="d-flex flex-row gap-2">
                <div class="select-wrapper w-100">
                  <select style="width: 100%;" class="form-select sombra-sm fondo-terciario borde-terciario texto-principal" v-model="observacion.TipoEvaluado" required>
                    <option value="Empleado">
                      {{ $t('empleado') }}
                    </option>
                    <option value="Profesor">
                      {{ $t('profesor') }}
                    </option>
                    <option value="Alumno">
                      {{ $t('alumno') }}
                    </option>
                    <option value="Familiar">
                      {{ $t('familiar') }}
                    </option>
                    <option value="Curso o Grupo">
                      {{ $t('cursoGrupo') }}
                    </option>
                    <option value="Personalizado">
                      {{ $t('personalizado') }}
                    </option>
                  </select>
                  <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                  </svg>
                </div>
              </div>
            </div>
            
            
            <!-- Botón Agregar Eleccion de Materia -->
            <button v-if="!observacion.ConEleccionMateria && observacion.TipoEvaluado == 'Profesor'" type="button" class="btn text-start texto-secundario fs-5 p-1" style="width: 300px;" @click="observacion.ConEleccionMateria = true">
              <svg class="mb-1" width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 12H18M12 6V18" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ $t('agregarEleccionMateria') }}
            </button>

            <div v-if="observacion.ConEleccionMateria">
              <label >{{ $t('materia') }}:</label>
              <div class="d-flex flex-row gap-2">
                <select style="width: 100%;" class="form-select sombra-sm" disabled>
                </select>
                
                <!-- Botón de eliminar, inicialmente oculto -->
                <button class="btn pb-2"
                        @click="observacion.ConEleccionMateria = false" type="button">
                  <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-secundario">
                    <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <div v-if="observacion.TipoEvaluado == 'Personalizado'">
              <!-- Botón Agregar Persona -->
              <button v-if="!observacion.AgregarPersona" class="btn text-start texto-secundario fs-5 p-1" type="button" style="width: 300px;" @click="observacion.AgregarPersona = true">
                <svg class="mb-1" width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 12H18M12 6V18" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{ $t('agregarPersona') }}
              </button>
              
              <div v-if="observacion.AgregarPersona" class="d-flex flex-column gap-2">
                <p class="m-0">{{ $t('agregarPersona') }}:</p>
                <div class="position-relative d-flex flex-row gap-2 w-100">
                  <input type="text" v-model="observacion.SearchQuery" :placeholder="$t('buscarPersona')+'...'" class="form-control sombra-sm w-100" @input="filterPersonas(observacion)"/>
                  <ul v-if="observacion.FilteredPersonas?.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%;">
                    <li v-for="evaluado in observacion.FilteredPersonas"  :key="evaluado.IdPersona"  class="list-group-item list-group-item-action" @click="selectPersona(evaluado, observacion)" style="cursor: pointer;">
                      {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
                    </li>
                  </ul>
                  <!-- Botones de acción -->
                  <div class="d-flex flex-row gap-2">
                    <button type="button" class="btn btn-success sombra-sm" @click="agregarPersona(observacion)">{{ $t('guardar') }}</button>
                    <button type="button" class="btn btn-secondary sombra-sm p-0 px-2" @click="cancelarAgregarPersona(observacion)">{{ $t('cancelar') }}</button>
                  </div>

                  <div v-if="loadingPersonas" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                    <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
                  </div>
                </div>
              </div>
              <!-- Lista de personas seleccionadas -->
              <div v-if="observacion.PersonasSeleccionadas">
                <div v-if="observacion.PersonasSeleccionadas?.length > 0">
                  <p class="m-0">{{ $t('personasSeleccionadas') }}:</p>
                  <ul class="list-group sombra-sm">
                    <li
                      v-for="(persona2, index) in observacion.PersonasSeleccionadas"
                      :key="persona2.IdPersona"
                      class="list-group-item d-flex justify-content-between align-items-center p-1 ps-3"
                    >
                      {{ persona2.Apellido + ' ' + persona2.Nombre }}
                      <!-- Botón de eliminar de la lista-->
                      <button type="button" class="btn pb-2" @click="eliminarPersona(index, observacion)">
                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-secundaria">
                          <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Divider -->
          <div v-if="!observacion.ConComentario && observacion.IdTipoObservacion != '989bec4b-779d-41b0-8b28-1f1487b59ded'.toLowerCase()" class="col-12 my-3 borde-linea" style="height: 1px"></div>
          <!-- Botón Agregar Comentario -->
          <button type="button" v-if="!observacion.ConComentario && observacion.IdTipoObservacion != '989bec4b-779d-41b0-8b28-1f1487b59ded'.toLowerCase()" class="btn text-start texto-secundario fs-5 p-1" style="width: 250px;" @click="observacion.ConComentario = true">
            <svg class="mb-1" width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12H18M12 6V18" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('agregarComentario') }}
          </button>
          <div v-if="observacion.ConComentario" class="position-relative" style="width: 100%;">
            <label for="descripcion">{{ $t('comentario') }}</label>
            <textarea id="descripcion" class="form-control fondo-secundario sombra-sm" style="height: 120px; resize: none;" maxlength="500" disabled></textarea>

            <button type="button" class="btn position-absolute pb-3 eliminar-comentario"
                    @click="observacion.ConComentario = false">
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-secundario">
                <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <div class="mt-2 text-end">
              <span>{{ form.Descripcion?.length }}/500 {{ $t('caracteres') }}</span>
            </div>
          </div>

          <!-- Divider -->
          <div v-if="observacion.Oculta" class="col-12 my-3 borde-linea" style="height: 1px"></div>

          <div v-if="observacion.Oculta">
            <p class="m-0">{{ $t('personasQuePuedenVerLaObservacion') }}:</p>
            <!-- Lista de personas seleccionadas -->
            <div v-if="observacion.ItemsObservacions.filter(item => item.ListaOculta === true).map(item => item.IdPersonaNavigation)">
              <div v-if="observacion.ItemsObservacions.filter(item => item.ListaOculta === true).map(item => item.IdPersonaNavigation).length > 0">
                <ul class="list-group sombra-sm">
                  <li
                    v-for="(persona2) in observacion.ItemsObservacions.filter(item => item.ListaOculta === true).map(item => item.IdPersonaNavigation)"
                    :key="persona2?.IdPersona"
                    class="list-group-item d-flex justify-content-between align-items-center p-1 ps-3 fondo-terciario borde-terciario texto-principal"
                  >
                    {{ persona2?.Apellido + ' ' + persona2?.Nombre }}
                    <!-- Botón de eliminar de la lista-->
                    <button type="button" class="btn pb-2" @click="eliminarPersonaVisual(persona2?.IdPersona, observacion)">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-secundario">
                        <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="observacion.AgregarPersonaVisual" class="d-flex flex-column gap-2">
              <p class="m-0">{{ $t('agregarPersona') }}:</p>
              <div class="position-relative d-flex flex-row gap-2 w-100">
                <input type="text" v-model="observacion.SearchQueryVisual" :placeholder="$t('buscarPersona')+'...'" class="form-control w-100" @input="filterPersonasVisual(observacion)"/>
                <ul v-if="observacion.FilteredPersonasVisual?.length > 0" class="list-group position-absolute" style="z-index: 1000; width: 100%; top: 100%;">
                  <li v-for="evaluado in observacion.FilteredPersonasVisual"  :key="evaluado?.IdPersona"  class="list-group-item list-group-item-action" @click="selectPersonaVisual(evaluado, observacion)" style="cursor: pointer;">
                    {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
                  </li>
                </ul>
                <!-- Botones de acción -->
                <div class="d-flex flex-row gap-2">
                  <button type="button" class="btn btn-success" @click="agregarPersonaVisual(observacion)">{{ $t('guardar') }}</button>
                  <button type="button" class="btn btn-secondary p-0 px-2" @click="cancelarAgregarPersonaVisual(observacion)">{{ $t('cancelar') }}</button>
                </div>

                <div v-if="loadingPersonasVisual" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                  <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
                </div>
              </div>
            </div>
            
            <!-- Botón Agregar Persona -->
            <button v-if="!observacion.AgregarPersonaVisual" class="btn text-start texto-secundario fs-5 p-1" type="button" style="width: 300px;" @click="observacion.AgregarPersonaVisual = true">
              <svg class="mb-1" width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 12H18M12 6V18" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ $t('agregarPersona') }}
            </button>
          </div>

          <!-- Divider -->
          <div class="col-12 my-3 borde-linea" style="height: 1px"></div>

          <div class="d-flex flex-row gap-3 align-items-center justify-content-end">
            <button type="button" class="btn p-0 pb-1" @click="removeObservation(indexObs)">
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-secundario">
                <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <!-- Divider Vertical -->
            <div v-if="form.ConAutorizaciones && (observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()||observacion.IdTipoObservacion === 'B3903AB7-FC85-45C3-AD59-7943330DB389'.toLowerCase())" class="col-12 borde-linea" style="height: 30px; width:1px"></div>
            <label v-if="form.ConAutorizaciones && (observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()||observacion.IdTipoObservacion === 'B3903AB7-FC85-45C3-AD59-7943330DB389'.toLowerCase())" for="minimoAutorizacion" class="m-0">{{ $t('minimoAutorizacion') }}:</label>
            <input v-if="form.ConAutorizaciones && (observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()||observacion.IdTipoObservacion === 'B3903AB7-FC85-45C3-AD59-7943330DB389'.toLowerCase())" type="number" id="minimoAutorizacion" v-model="observacion.MinimoAutorizacion" class="form-control" style="max-width: 100px;"/>
            <!-- Divider Vertical -->
            <div class="col-12 borde-linea" style="height: 30px; width:1px"></div>
            <!-- Switch para indicar si la observación es obligatoria -->
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" v-model="observacion.Oculta" >
              <label class="form-check-label" style="margin-top: 2px;" for="flexSwitchCheckDefault">{{ $t('obsOculta') }}</label>
            </div>
            <!-- Divider Vertical -->
            <div class="col-12 borde-linea" style="height: 30px; width:1px"></div>
            <!-- Switch para indicar si la observación es obligatoria -->
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" v-model="observacion.Obligatorio" >
              <label class="form-check-label" style="margin-top: 2px;" for="flexSwitchCheckDefault">{{ $t('obligatorio') }}</label>
            </div>
          </div>
        </div>
        
      </div>

      <!-- Botón Agregar Observacion -->
      <button type="button" class="btn text-start texto-secundario fs-5 p-1" style="width: 250px;" @click="addObservation">
        <svg class="mb-1" width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12H18M12 6V18" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ $t('agregarObservacion') }}
      </button>

      <div class="d-flex gap-2 mt-4">
        <button type="submit" class="btn btn-success" :disabled="isSaving">{{ $t('guardar') }}</button>
        <div v-if="isSaving" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
        </div>
        <button class="btn btn-danger" type="button" @click="cancelForm">{{ $t('cancelar') }}</button>
      </div>
    </form>
  </div>
    
  <div v-if="!form.IdFormulario" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
    <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
  </div>
</template>

<script>
  import { ref, computed, onMounted, toRaw, watch } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const MenuVisible = ref(1);
    const form = ref({
      Descripcion: '',
      TituloEleccionEvaluado: false,
      ConEleccionEvaluado: false,
      FechaCreacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      FechaModificacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      IdModificadoPor: null,
      IdCreador: null,
      IdFormulario: null,
      NombreFormulario: '',
      ConAccesoRestringido: false,
      Observacions: [], // Array de objetos para observaciones
    });
    const tiposObservacion = ref([]);
    const currentValue = ref(3);
    const isSaving = ref(false);
    const loadingForm = ref(false);
    const loadingFile = ref(false);
    const persona = ref([]);
    const empleados = ref([]);
    const loadingPersonas = ref(false);
    const verOpciones = ref(false);
    //const loadingPersonasVisual = ref(false);
    const selectedPersona = ref(null);
    const grupoSeleccionado = ref('');
    const gruposDisponibles = ref([]);
    const gruposDisponiblesPermisos = ref([]);

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        
      var permisoAComprobar = 'VerFormularios'
      if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
      }
    };

    const fileInput = ref(null)

    const selectImage = () => {
      fileInput.value.click() // Activa el input de archivo
    }

    // Función para manejar la carga de archivos
    const handleFileUpload = async (event) => {
      const file = event.target.files[0];
      if (file) {
        try {
          loadingFile.value = true;
          const archivoData = new FormData();
          archivoData.append('archivo', file); // Agrega el archivo

          const response = await api.post(`api/Archivos`, archivoData, {
            params: {
              hotlink: true,
            },
            headers: {
              'Content-Type': 'multipart/form-data', // Asegúrate de enviar el tipo de contenido correcto
            },
          });
          form.value.PortadaUrl = response.data.enlace; // Asigna la URL del archivo subido al campo ImagenUrl
          loadingFile.value = false;
          
        } catch (error) {
          console.error('Error al subir archivo:', error);
        }
      }
    };
    // Obtener los tipos de observación desde la API
    const fetchTiposObservacion = async () => {
      try {
        const response = await api.get(`api/Observaciones/TipoObservaciones`);
        tiposObservacion.value = response.data;
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };
    // Obtener los grupos desde la API
    const fetchGrupos = async () => {
      try {
        const response = await api.get(`api/Grupos`);
        
        response.data.forEach(grupo =>{
          gruposDisponibles.value.push({
            id: grupo.IdGrupo,
            nombre: grupo.Nombre + ' Responsables'
          })
          gruposDisponiblesPermisos.value.push({
            id: grupo.IdGrupo,
            nombre: grupo.Nombre
          })
        })
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    const addObservation = () => {
      if (!form.value.Observacions) {
        form.value.Observacions = []; // Inicializa si no está definido
      }
      // Asignar el primer valor de tiposObservacion como el valor por defecto
      let defaultTipoObservacion = '';
      if(tiposObservacion.value){
        defaultTipoObservacion = tiposObservacion.value?.length > 0 ? tiposObservacion.value[0].IdTipoObservacion : '';
      }

      const nextOrderNumber = form.value.Observacions?.length + 1;
      form.value.Observacions.push({
        IdTipoObservacion: defaultTipoObservacion, // Inicializa el tipo de observación
        NombreObservacion: '',
        Descripcion: '',
        NroOrden: nextOrderNumber,
        Obligatorio: false,
        ConComentario: false,
        ItemsObservacions: [], // Asegúrate de inicializar el array de items
        ShowAddItem: false, // Controla la visibilidad del campo de agregar item
        NewItemName: '', // Asegúrate de inicializar el nuevo item
        PersonasSeleccionadas: [],
        AgregarPersona: false,
        AgregarPersonaVisual: false,
        FilteredPersonas: [],
        FilteredPersonasVisual: [],
        MinimoAutorizacion: 0,
        SearchQuery: '',
        SearchQueryVisual: '',
      });
    };

    const removeObservation = async (index) => {
      if (confirm("¿Estás seguro de que deseas borrar la observación?")) {
        const check = await checkValores(form.value.Observacions[index].IdObservacion);
        if(form.value.Observacions && check){
          form.value.Observacions.splice(index, 1);
        }
        else{
          confirm("La observacion tiene Valores. No se puede borrar")
        }
      }
    };

    const checkValores = async (id) => {
      try {
        const response = await api.get(`api/Valores/ByIdObservacion`, {
          params: { id: id },
        });

        if(response.data?.length>0){
          return false //Hay valores, asi que NO se puede borrar
        }
        else{
          return true //No hay valores, asi que se puede borrar
        }
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };

    const checkAutorizaciones = async (id) => {
      try {
        if(id=='00000000-0000-0000-0000-000000000000' || id == null){
          return false;
        }
        const response = await api.get(`api/Autorizaciones/ByIdAutorizador`, {
          params: { id: id },
        });

        if(response.data?.length>0){
          return true //Hay autorizaciones, asi que NO se puede borrar
        }
        else{
          return false //No hay autorizaciones, asi que se puede borrar
        }
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };

    const moveUp = (index, observacion) => {
      if(observacion && observacion.ItemsObservacions && index > 0){
          const current = observacion.ItemsObservacions[index];
          const previous = observacion.ItemsObservacions[index - 1];

          // Intercambiar NroOrden
          const tempOrder = current.NroOrden;
          current.NroOrden = previous.NroOrden;
          previous.NroOrden = tempOrder;

          // Reordenar elementos
          observacion.ItemsObservacions.splice(index - 1, 2, current, previous);
      }else{
        if (index > 0) {
          const current = form.value.Observacions[index];
          const previous = form.value.Observacions[index - 1];

          // Intercambiar NroOrden
          const tempOrder = current.NroOrden;
          current.NroOrden = previous.NroOrden;
          previous.NroOrden = tempOrder;

          // Reordenar elementos
          form.value.Observacions.splice(index - 1, 2, current, previous);
        }
      }
    };

    const moveDown = (index, observacion) => {
      if(observacion && index < observacion.ItemsObservacions?.length - 1){
          const current = observacion.ItemsObservacions[index];
          const next = observacion.ItemsObservacions[index + 1];

          // Intercambiar NroOrden
          const tempOrder = current.NroOrden;
          current.NroOrden = next.NroOrden;
          next.NroOrden = tempOrder;

          // Reordenar elementos
          observacion.ItemsObservacions.splice(index, 2, next, current);
      }else{
        if (index < form.value.Observacions?.length - 1) {
          const current = form.value.Observacions[index];
          const next = form.value.Observacions[index + 1];

          // Intercambiar NroOrden
          const tempOrder = current.NroOrden;
          current.NroOrden = next.NroOrden;
          next.NroOrden = tempOrder;

          // Reordenar elementos
          form.value.Observacions.splice(index, 2, next, current);
        }
      }
    };
    
    // Obtener los tipos de observación desde la API
    const fetchPersonas = async () => {
      try {
        loadingPersonas.value = true;

        const response2 = await api.get(`api/Persona/ByRole?role=Empleado`);
        empleados.value = response2.data;

        let response;
        response = await api.get(`api/Persona/ByEstado?estado=Activo`);
        persona.value = response.data;
        
        loadingPersonas.value = false;
      } catch (error) {
        loadingPersonas.value = false;
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    // Filtrar personas basadas en el input de búsqueda
    const filterPersonas = (observacion) => {
      if (!observacion.SearchQuery) {
        observacion.FilteredPersonas = [];
      } else {
        const query = observacion.SearchQuery.toLowerCase();
        observacion.FilteredPersonas = persona.value.filter(evaluado =>
          `${evaluado.Apellido} ${evaluado.Nombre}`.toLowerCase().includes(query)
        ).slice(0, 10);
      }
    };

    const selectPersona = (evaluado,observacion) => {
      selectedPersona.value = evaluado.IdPersona; // Asigna la persona seleccionada
      observacion.SearchQuery = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      observacion.FilteredPersonas = []; // Limpia la lista filtrada
    };

    const agregarPersona = (observacion) => {
      const persona1 = persona.value.find(
        (p) => `${p.Apellido} ${p.Nombre}` === observacion.SearchQuery
      );
      if (persona1 && !observacion.PersonasSeleccionadas.some((p) => p.IdPersona === persona1.IdPersona)) {
        observacion.PersonasSeleccionadas.push(persona1);
        observacion.SearchQuery = '';
      }
    };

    const cancelarAgregarPersona = (observacion) => {
      observacion.AgregarPersona = false;
      observacion.SearchQuery = '';
      observacion.FilteredPersonas = [];
    };

    const eliminarPersona = (index, observacion) => {
      observacion.PersonasSeleccionadas.splice(index, 1);
    };

    // Filtrar personas basadas en el input de búsqueda
    const filterPersonasAutorizadores = (nivel) => {
      if (!nivel.SearchQueryAutorizadores) {
        nivel.FilteredPersonasAutorizadores = [];
      } else {
        const query = nivel.SearchQueryAutorizadores.toLowerCase();
        nivel.FilteredPersonasAutorizadores = empleados.value.filter(evaluado =>
          `${evaluado.Apellido} ${evaluado.Nombre}`.toLowerCase().includes(query)
        ).slice(0, 10);
      }
    };

    const selectPersonaAutorizadores = (evaluado, nivel) => {
      selectedPersona.value = evaluado.IdPersona; // Asigna la persona seleccionada
      nivel.SearchQueryAutorizadores = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      nivel.FilteredPersonasAutorizadores = []; // Limpia la lista filtrada
    };

    const agregarGrupoAutorizadores = async (nivel) => {
      let esGrupo = false;
      gruposDisponibles.value.forEach(grupo => {
        if(grupo.id == grupoSeleccionado.value){
          if(!grupo.nombre.includes('-')){
            esGrupo=true
          }
        }
      })
      if(esGrupo){
        const response = await api.get(`api/Grupos/`+grupoSeleccionado.value);
        response.data.Listas.forEach(lista => {
          if (lista.PersonaResponsable && !nivel.Autorizadores.some(p => p.IdPersona === lista.PersonaResponsable.IdPersona)) {
            nivel.Autorizadores.push({
              IdAutorizador: '00000000-0000-0000-0000-000000000000',
              IdFormulario: '00000000-0000-0000-0000-000000000000',
              IdPersona: lista.PersonaResponsable.IdPersona,
              Persona: lista.PersonaResponsable,
              Inhabilitado: false,
            });
          }
        })
      } else {
        const response = await api.get(`api/Grupos/opciones/`+grupoSeleccionado.value);
        response.data.Listas.forEach(lista => {
          lista.PersonasRelacionadas.forEach(personasRel => {
            if (personasRel.Persona && !nivel.Autorizadores.some(p => p.IdPersona === personasRel.Persona.IdPersona)) {
              nivel.Autorizadores.push({
                IdAutorizador: '00000000-0000-0000-0000-000000000000',
                IdFormulario: '00000000-0000-0000-0000-000000000000',
                IdPersona: personasRel.Persona.IdPersona,
                Persona: personasRel.Persona,
                Inhabilitado: false,
              });
            }
          })
        })
      }
      nivel.ShowAddAutorizador = false
      nivel.modoAgregar = ''
      nivel.SearchQueryAutorizadores = ''
      nivel.FilteredPersonasAutorizadores = []
    };

    const cancelarPersonaAutorizadores = (nivel, index) => {
      nivel.ShowAddAutorizador = false;
      nivel.SearchQueryAutorizadores = ''
      if(nivel.Autorizadores?.length==0){
        form.value.AutorizadoresNivel.splice(index, 1);
      }
    }

    const agregarPersonaAutorizadores = (orden, nivel) => {
      const persona1 = empleados.value.find(
        (p) => `${p.Apellido} ${p.Nombre}` === nivel.SearchQueryAutorizadores
      );
      if (!persona1) return; // Si no hay persona, salir

      const autorizadoresNivel = form.value.AutorizadoresNivel || [];

      // Buscar si ya existe un nivel con ese orden
      let nivelExistente = autorizadoresNivel.find(nivel => nivel.NroOrden === orden);

      // Ya existe el nivel, agregamos el autorizador al nivel
      if (!nivelExistente.Autorizadores) {
        nivelExistente.Autorizadores = [];
      }

      // Verificar que no esté ya en los autorizadores
      const yaExiste = nivelExistente.Autorizadores.some(a => a.IdPersona === persona1.IdPersona);
      if (!yaExiste) {
        nivelExistente.Autorizadores.push({
          IdAutorizadoresNivel: nivelExistente.IdAutorizadoresNivel || '00000000-0000-0000-0000-000000000000',
          IdAutorizador: '00000000-0000-0000-0000-000000000000',
          IdPersona: persona1.IdPersona,
          Persona: persona1,
          Inhabilitado: false,
        });
      }else{
        alert("La persona ya esta como autorizador")
      }

      nivel.ShowAddAutorizador = false
      nivel.modoAgregar = ''
      nivel.SearchQueryAutorizadores = ''
      nivel.FilteredPersonasAutorizadores = []
      Object.keys(nivel.ShowAddAutorizador).forEach(k => nivel.ShowAddAutorizador[k] = false);
    };

    const agregarNivel = () => {
      form.value.AutorizadoresNivel.push({
          IdAutorizadoresNivel: '00000000-0000-0000-0000-000000000000',
          IdFormulario: form.value.IdFormulario,
          NroOrden: form.value.AutorizadoresNivel?.length+1,
          TipoPermiso: 'Todos',
          EnviarEmailCambioEstado: false,
          EnviarEmailAAutorizadores: true,
          EnviarEmailResumenDiario: false,
          SePuedenAutoAutorizar: false,
          Autorizadores: [],
          Estados: [
            {
              IdAutorizacionEstado: '00000000-0000-0000-0000-000000000000',
              IdAutorizadoresNivel: '00000000-0000-0000-0000-000000000000',
              EstadoNombre: 'Aprobado',
              Autorizado: true,
            },
            {
              IdAutorizacionEstado: '00000000-0000-0000-0000-000000000000',
              IdAutorizadoresNivel: '00000000-0000-0000-0000-000000000000',
              EstadoNombre: 'Rechazado',
              Autorizado: false,
            }
          ],
          ShowAddAutorizador: false,
          modoAgregar: '',
          SearchQueryAutorizadores: '',
          FilteredPersonasAutorizadores: [],
      });
    }

    const removeNivel = async (index) => {
      if (confirm("¿Estás seguro de que deseas borrar el paso de autorización?")) {
        if(form.value.AutorizadoresNivel){
          form.value.AutorizadoresNivel.splice(index, 1);
        }
        else{
          confirm("Se ha producido un error al borrar el paso de autorización")
        }
      }
    };

    const generarUUID = () => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    const agregarEstado = (nivelExistente) => {
      // Inicializamos Estados al nivel
      if (!nivelExistente.Estados) {
        nivelExistente.Estados = [];
      }

      nivelExistente.Estados.push({
        IdAutorizadoresNivel: nivelExistente.IdAutorizadoresNivel || '00000000-0000-0000-0000-000000000000',
        IdAutorizacionEstado: generarUUID(),//este id es temporal, en el back se crea otro
        EstadoNombre: '',
        Autorizado: true,
      });
    }

    const borrarPersona = async (index, i, id) => {
      var nivel = form.value.AutorizadoresNivel[index];
      if(await checkAutorizaciones(id)){
        nivel.Autorizadores[i].Inhabilitado = true
      }else{
        nivel.Autorizadores = nivel.Autorizadores.filter(a => a.IdPersona !== nivel.Autorizadores[i].Persona?.IdPersona);
        if(nivel.Autorizadores?.length == 0){
          form.value.AutorizadoresNivel.splice(index, 1);
        }
      }
    }

    // Filtrar personas basadas en el input de búsqueda
    const filterPersonasVisual = (observacion) => {
      if (!observacion.SearchQueryVisual) {
        observacion.FilteredPersonasVisual = [];
      } else {
        const query = observacion.SearchQueryVisual.toLowerCase();
        observacion.FilteredPersonasVisual = persona.value.filter(evaluado =>
          `${evaluado.Apellido} ${evaluado.Nombre}`.toLowerCase().includes(query)
        ).slice(0, 10);
      }
    };

    const selectPersonaVisual = (evaluado,observacion) => {
      selectedPersona.value = evaluado.IdPersona; // Asigna la persona seleccionada
      observacion.SearchQueryVisual = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      observacion.FilteredPersonasVisual = []; // Limpia la lista filtrada
    };

    const agregarPersonaVisual = (observacion) => {
      const persona1 = persona.value.find(
        (p) => `${p.Apellido} ${p.Nombre}` === observacion.SearchQueryVisual
      );
      if (persona1 && !observacion.ItemsObservacions.filter(item => item.ListaOculta === true).some((p) => p.IdPersona === persona1.IdPersona)) {
        observacion.ItemsObservacions.push({
          IdItemsObservacion: '00000000-0000-0000-0000-000000000000',
          IdObservacion: observacion.IdObservacion,
          IdPersona: persona1.IdPersona,
          IdPersonaNavigation: persona1,
          ListaOculta: true
        });
        observacion.SearchQueryVisual = '';
      }
    };

    const cancelarAgregarPersonaVisual = (observacion) => {
      observacion.AgregarPersonaVisual = false;
      observacion.SearchQueryVisual = '';
      observacion.FilteredPersonasVisual = [];
    };

    const eliminarPersonaVisual = (idPersona, observacion) => {
      observacion.ItemsObservacions = observacion.ItemsObservacions.filter(item => item.ListaOculta === true).filter(item => item.IdPersona !== idPersona);
    };

    const fetchForm = async () => {
      try {
        loadingForm.value = true;
        const idForm = localStorage.getItem('idForm');
        const response = await api.get(`api/Formularios/ByIdBasicoVer`, {
          params: {
            id: idForm
          },
        });
        form.value = response.data.Formulario;
        const tipoPermiso = response.data.TipoPermiso;
        // Add the additional properties to each observation
        if (form.value && Array.isArray(form.value.Observacions)) {
          form.value.Observacions.forEach(obs => {
            if(obs.TipoEvaluado == "Personalizado"){
              obs.PersonasSeleccionadas = obs.ItemsObservacions.filter(item => item.ListaOculta === false || item.ListaOculta === null).map(item => item.IdPersonaNavigation);
              obs.AgregarPersona = false;
              obs.FilteredPersonas = [];
              obs.SearchQuery = '';
            }
            obs.AgregarPersonaVisual= false;
            obs.FilteredPersonasVisual= [];
            obs.SearchQueryVisual= '';
          });
        }
        // Add the additional properties to each nivel
        if (form.value && Array.isArray(form.value.AutorizadoresNivel)) {
          form.value.AutorizadoresNivel.forEach(nivel => {
            nivel.ShowAddAutorizador = false;
            nivel.modoAgregar = '';
            nivel.SearchQueryAutorizadores = '';
            nivel.FilteredPersonasAutorizadores = []
          });
        }

        if(tipoPermiso == "Editor"){
          console.log('Tiene permisos de edicion')
        } else{
          const accesoCompletador = form.value.AccesoFormularios.find(acceso => (acceso.IdPersona === user?.value.idPersona || acceso.IdOpcionGrupoNavigation?.PersonasRelacionadas?.some(pr => pr.IdPersona == user?.value.idPersona)) && acceso.TipoPermiso == "Completador" );
          if (accesoCompletador) {
            console.log('Tiene permisos de completar')
            await router.push('/formularios/completar');
          }
          else{
            console.log('No tiene permisos de edicion')
            await router.push('/formularios');
          }
        }

        loadingForm.value = false;
        //addValor();
      } catch (error) {
        loadingForm.value = false;
        console.error('Error al obtener formularios:', error);
      }
    };

    const submit = async () => {
      if (form.value.Observacions?.length === 0) {
        alert("Por favor, agrega al menos una observación.");
        return;
      }
      // Lógica para guardar el formulario
      try {
        isSaving.value = true;

        // Filtrar observaciones con TipoEvaluado === 'Personalizado'
        form.value.Observacions.forEach((obs, index) => {
          //Actualizar orden cada vez porque se puede arruinar
          obs.NroOrden = index+1;

          if (obs.TipoEvaluado === 'Personalizado') {
            // Si no existe un array para itemsObservacion, inicializarlo
            obs.ItemsObservacions = [];

            // Agregar un nuevo item para cada persona seleccionada
            obs.PersonasSeleccionadas.forEach(persona => {
              obs.ItemsObservacions.push({
                IdItemsObservacion: '00000000-0000-0000-0000-000000000000',
                IdPersona: persona.IdPersona,
              });
            });

            form.value.Observacions[index] = obs;
          }
          
        });
        const cleanedObservations = form.value.Observacions.map(observacion => {
          return {
            IdObservacion: observacion.IdObservacion,
            IdTipoObservacion: observacion.IdTipoObservacion,
            NroOrden: observacion.NroOrden,
            NombreObservacion: observacion.NombreObservacion,
            Descripcion: observacion.Descripcion,
            Obligatorio: observacion.Obligatorio,
            ConComentario: observacion.ConComentario,
            TipoEvaluado: observacion.TipoEvaluado,
            ConEleccionMateria: observacion.ConEleccionMateria,
            Oculta: observacion.Oculta,
            MinimoAutorizacion: observacion.MinimoAutorizacion,
            ItemsObservacions: observacion.ItemsObservacions.map(item => {
              return {
                NombreItem: item.NombreItem,
                ValorDeRango: item.ValorDeRango,
                NroOrden: item.NroOrden,
                ListaOculta: item.ListaOculta,
                IdObservacion: observacion.IdObservacion,
                IdItemsObservacion: item.IdItemsObservacion || null,
                IdCurso: item.IdCurso || null,
                IdPersona: item.IdPersona || null
              };
            }),
          };
        });

        if(form.value.Anonimo){
          form.value.ConRespuesta = false;
          form.value.AQuienesResponden = null;
        }
        
        // Asigna la versión limpia a form
        form.value.Observacions = cleanedObservations;
        form.value.IdModificadoPor = user?.value.idPersona;
        form.value.PreferenciasDeNotificaciones = null
        const cleanForm = JSON.stringify(toRaw(form.value), null, 2); 
        
        await api.put(`api/Formularios`, cleanForm);
        await router.push('/formularios/ver?idForm='+form.value.IdFormulario)
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };

    const addRangeItems = (observacion) => {
      if (!observacion.ItemsObservacions) {
        observacion.ItemsObservacions = [];
      }

      const requiredItems = [
        { NombreItem: 'Minimo', ValorDeRango: 0, IdItemsObservacion: '00000000-0000-0000-0000-000000000000' },
        { NombreItem: 'Maxima', ValorDeRango: 10, IdItemsObservacion: '00000000-0000-0000-0000-000000000000' },
        { NombreItem: 'StepValue', ValorDeRango: 1, IdItemsObservacion: '00000000-0000-0000-0000-000000000000' },
      ];

      // Agregar los ítems si no existen
      for (const item of requiredItems) {
        if (!observacion.ItemsObservacions.some(i => i.NombreItem === item.NombreItem)) {
          observacion.ItemsObservacions.push(item);
        }
      }
    };

    const deleteRangeItems = (observacion) => {
      if (observacion.ItemsObservacions?.length > 0) {
        //Se asegura de borrar solo cuando son items de rango
        if(observacion.ItemsObservacions[0].NombreItem=="Minimo"||observacion.ItemsObservacions[0].NombreItem=="Maxima"||observacion.ItemsObservacions[0].NombreItem=="StepValue"){
          observacion.ItemsObservacions = [];
        }
      }
    };

    watch(
      () => form.value.Observacions,
      (observacions) => {
        observacions.forEach((observacion) => {
          if (observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()) {
            addRangeItems(observacion);
          } else {
            deleteRangeItems(observacion);
          }
        });
      },
      { immediate: true, deep: true }
    );

    const cancelForm = async() => {
      await router.push(`/formularios/ver?idForm=${form.value.IdFormulario}`);
    };

    const toggleAddItem = (index) => {
      form.value.Observacions[index].ShowAddItem = !form.value.Observacions[index].ShowAddItem;
    };

    const confirmAddItem = (index) => {
      const newItem = form.value.Observacions[index].NewItemName.trim();
      if (newItem) {
        let lastOrderNum = 1
        if(form.value.Observacions[index].ItemsObservacions){
          if(form.value.Observacions[index].ItemsObservacions?.length > 0){
            lastOrderNum = form.value.Observacions[index].ItemsObservacions[form.value.Observacions[index].ItemsObservacions?.length-1].NroOrden + 1
          }
        }
        form.value.Observacions[index].ItemsObservacions.push({ NombreItem: newItem, ValorDeRango :null, NroOrden: lastOrderNum ,IdItemsObservacion: '00000000-0000-0000-0000-000000000000' });
        form.value.Observacions[index].NewItemName = ''; // Limpia el campo
      }
      form.value.Observacions[index].ShowAddItem = false; // Oculta el campo después de agregar
    };

    const cancelAddItem = (index) => {
      form.value.Observacions[index].ShowAddItem = false; // Oculta el campo sin agregar
    };

    const removeItem = (index, indexItem) => {
      form.value.Observacions[index].ItemsObservacions.splice(indexItem, 1);
    };
    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();
      fetchPersonas();
      fetchForm();
      fetchTiposObservacion();
      fetchGrupos();
    });

    return {
      form,
      addObservation,
      removeObservation,
      removeNivel,
      submit,
      cancelForm,
      tiposObservacion,
      toggleAddItem,
      confirmAddItem,
      cancelAddItem,
      currentValue,
      removeItem,
      t,
      moveUp,
      moveDown,
      isSaving,
      agregarPersona,
      eliminarPersona,
      cancelarAgregarPersona,
      selectPersona,
      agregarPersonaVisual,
      eliminarPersonaVisual,
      cancelarAgregarPersonaVisual,
      selectPersonaVisual,
      filterPersonasVisual,
      filterPersonas,
      loadingPersonas,
      persona,
      fetchPersonas,
      handleFileUpload,
      selectImage,
      fileInput,
      loadingFile,
      filterPersonasAutorizadores,
      selectPersonaAutorizadores,
      agregarPersonaAutorizadores,
      empleados,
      grupoSeleccionado,
      gruposDisponibles,
      gruposDisponiblesPermisos,
      agregarGrupoAutorizadores,
      agregarNivel,
      agregarEstado,
      borrarPersona,
      cancelarPersonaAutorizadores,
      verOpciones,
      MenuVisible
    };
  },
};
</script>

<style scoped>

.position-relative {
position: relative;
}

.eliminar-comentario {
display: none;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
}

.position-relative:hover .eliminar-comentario {
display: block;
}
</style>
